/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TituloEmpleoIdJobTitleGet$Params {
  idJobTitle: string;
}

export function tituloEmpleoIdJobTitleGet(http: HttpClient, rootUrl: string, params: TituloEmpleoIdJobTitleGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, tituloEmpleoIdJobTitleGet.PATH, 'get');
  if (params) {
    rb.path('idJobTitle', params.idJobTitle, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

tituloEmpleoIdJobTitleGet.PATH = '/titulo-empleo/{idJobTitle}';
